"use strict";

import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
var financeurSubventionSelectPopinModal = {
  controller: "financeurSubventionSelectPopinController",
  template: require("./financeurSubventionSelectPopin.html"),
  options: {
    width: 800
  }
};
ngModule.factory("financeurSubventionSelectPopin", function ($modal) {
  return {
    open: function open() {
      return $modal.open(_objectSpread({}, financeurSubventionSelectPopinModal));
    }
  };
});
ngModule.controller("financeurSubventionSelectPopinController", function ($scope, contrepartieService, financeurSubventionSearchMatcher, $dialogBox, $modal, $http, $timeout, $element) {
  var ctrl = this;
  ctrl.searchTerm = "";
  ctrl.financeurs = [];
  contrepartieService.getFinanceursSubvention().then(function (financeurs) {
    ctrl.financeurs = financeurs;
    refreshResults();
  });
  $timeout(function () {
    $element.find('.tl-select-searchbox')[0].focus();
  }, 100, false);
  $scope.selectBanque = function (financeur) {
    $scope.$close(financeur);
  };
  $scope.$watch(function () {
    return ctrl.searchTerm;
  }, function () {
    return refreshResults();
  });
  var refreshResults = function refreshResults() {
    var filtered = _.filter(ctrl.financeurs, function (b) {
      return financeurSubventionSearchMatcher(ctrl.searchTerm, b);
    });
    var groups = [];
    _.each(filtered, function (option) {
      var optGroupByValue = option.groupLabel;
      var group = _.find(groups, {
        value: optGroupByValue
      });
      if (group == null) {
        group = {
          value: optGroupByValue,
          options: []
        };
        groups.push(group);
      }
      group.options.push(option);
    });
    ctrl.results = groups;
  };
  $scope.demandeCreationFinanceur = function () {
    $modal.open({
      controller: "DemandeCreationFinanceurPopinController",
      template: require("./demande-creation-financeur/demande-creation-financeur-popin.html")
    }).then(function (message) {
      $http.post("/rest/aide-subvention/financeur-subvention/demande-creation", message.comment).then(function () {
        $dialogBox.alert({
          title: 'Demande création effectuée',
          html: '<p>La demande a été transmise. Elle sera réalisé dans les meilleurs délais. ' + 'Un ticket a été créé sur la plateforme pour vous permettre de suivre le traitement de votre demande.</p>' + '<p>En attendant, nous vous suggérons de choisir dans la liste des financeurs \'<span class="b">Autre</span>\'. ' + 'Vous pourrez modifier ce financeur une fois celui demandé créé.</p>'
        });
      });
    });
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/selectbox/configs/finaceursSubvention/financeurSubventionSelectPopin.js
// module id = 2996
// module chunks = 13